<template>
  <div>
    <custom-actions show-back>
      <el-form class="form" v-loading="loading" :model="formData" ref="formData" label-width="140px">
        <el-row :span="24">
          <el-col :span="12">
            <el-form-item label="出库时间" prop="outboundTime">
              {{ formatDate(formData.outboundTime, 'YYYY-MM-DD HH:mm:ss') }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="产品名称" prop="productName">
              {{ formData.productName || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="产品规格" prop="productSpecName">
              {{ formData.productSpecName || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="生产单号" prop="recordNumber">
              {{ formData.recordNumber || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="生产日期" prop="productionDate">
              {{ formatDate(formData.productionDate) }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="出库数量" prop="outboundQuantity">
              {{ formData.outboundQuantity === '' || formData.outboundQuantity == null ? '--' : formData.outboundQuantity }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="发货人" prop="shipperUserName">
              {{ formData.shipperUserName || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="领货人" prop="receiverUserName">
              {{ formData.receiverUserName || '--' }}
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item>
          <el-button v-if="loadFailed" @click="loadDetails" class="global-button">重新加载</el-button>
          <el-button @click="$router.back()" class="global-button">返回</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>
  </div>
</template>

<script>
import dayjs from 'dayjs'

export default {
  name: 'FinishedGoodsOutboundDetail',
  data() {
    return {
      loading: false,
      loadFailed: false,
      formData: {
        outboundId: '', // 成品出库ID
        outboundTime: '', // 出库时间
        productName: '', // 产品名称
        productSpecName: '', // 产品规格
        recordNumber: '', // 生产单号
        productionDate: '', // 生产日期
        outboundQuantity: '', // 出库数量
        shipperUserName: '', // 发货人
        receiverUserName: '' // 领货人
      }
    }
  },
  computed: {
    outboundId() {
      return this.$route.query.outboundId
    }
  },
  created() {
    this.loadDetails()
  },
  methods: {
    formatDate(value, format = 'YYYY-MM-DD') {
      return value ? dayjs(value).format(format) : '--'
    },
    loadDetails() {
      if (!this.outboundId) {
        this.$message.warning('缺少记录ID')
        return
      }
      this.loading = true
      this.loadFailed = false
      return this.$axios.get(this.$apis.prodManage.selectScFinishedGoodsOutboundById, {
        params: { outboundId: this.outboundId }
      }).then(res => {
        this.formData = res
      }).catch(() => {
        this.loadFailed = true
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style scoped lang="scss">
.form {
  word-break: break-all;
}
</style>
